var map = {
	"./1.jpeg": 1021,
	"./2.jpeg": 7232,
	"./3.jpeg": 3326,
	"./4.jpeg": 5669,
	"./5.jpeg": 9482,
	"./6.jpeg": 8946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9615;